import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { en } from './en'
import { no } from './no'
import { lt } from './lt'
import { pl } from './pl'
import { sv } from './sv'

Vue.use(VueI18n)

const messages = { en, no, lt, pl, sv }

const i18n = new VueI18n({
  locale: 'no',
  messages,
  // WIT-FIX-CERT-5355-001: a missing key renders as words (last segment,
  // underscores split), never as the uppercased key path.
  missing: (locale, key) => {
    const last = String(key || '').split('.').pop() || ''
    const words = last.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim().toLowerCase()
    return words ? words.charAt(0).toUpperCase() + words.slice(1) : key
  }
})
export default i18n
